import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = {
  key: 1,
  class: "error-container"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 0,
  class: "first-box"
}
const _hoisted_6 = ["src", "onClick"]
const _hoisted_7 = ["src", "alt", "onClick"]
const _hoisted_8 = {
  key: 1,
  class: "second-box"
}
const _hoisted_9 = ["src", "onClick"]
const _hoisted_10 = ["src", "alt", "onClick"]
const _hoisted_11 = {
  key: 0,
  class: "empty-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "loading-spinner" }, null, -1),
          _createElementVNode("p", null, "加载中...", -1)
        ]))]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", null, "加载失败：" + _toDisplayString(_ctx.error), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fetchData && _ctx.fetchData(...args))),
              class: "retry-button"
            }, "重试")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topics, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `topic-${item.id || index}`
              }, [
                (item.themeType === 'one')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDisplayImages(item), (image, imgIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `one-img-${image.id || imgIndex}`
                        }, [
                          (_ctx.isVideo(image.url))
                            ? (_openBlock(), _createElementBlock("video", {
                                key: 0,
                                src: _ctx.trimImageUrl(image.url),
                                autoplay: "",
                                muted: "",
                                loop: "",
                                playsinline: "",
                                class: "responsive-image",
                                onClick: ($event: any) => (_ctx.goToDetail(image.id)),
                                style: {"cursor":"pointer"}
                              }, null, 8, _hoisted_6))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: _ctx.trimImageUrl(image.url),
                                alt: item.name || 'Single Image',
                                class: "responsive-image",
                                onClick: ($event: any) => (_ctx.goToDetail(image.id)),
                                style: {"cursor":"pointer"}
                              }, null, 8, _hoisted_7))
                        ]))
                      }), 128))
                    ]))
                  : (item.themeType === 'four')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDisplayImages(item), (image, imgIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `four-img-${image.id || imgIndex}`,
                            class: "grid-item"
                          }, [
                            (_ctx.isVideo(image.url))
                              ? (_openBlock(), _createElementBlock("video", {
                                  key: 0,
                                  src: _ctx.trimImageUrl(image.url),
                                  autoplay: "",
                                  muted: "",
                                  loop: "",
                                  playsinline: "",
                                  class: "responsive-image",
                                  onClick: ($event: any) => (_ctx.goToDetail(image.id)),
                                  style: {"cursor":"pointer"}
                                }, null, 8, _hoisted_9))
                              : (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: _ctx.trimImageUrl(image.url),
                                  alt: item.name || 'Single Image',
                                  class: "responsive-image",
                                  onClick: ($event: any) => (_ctx.goToDetail(image.id)),
                                  style: {"cursor":"pointer"}
                                }, null, 8, _hoisted_10))
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.topics.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("p", null, "暂无数据", -1)
                ]))]))
              : _createCommentVNode("", true)
          ]))
  ]))
}